import { Header as OriginalHeader } from '@showclix-shared/ListingComponents';
import { FunctionComponent, PropsWithChildren } from 'react';
import { useAppData } from '@/contexts/AppData';

export const Header: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { uiConfig } = useAppData();

  return (
    <OriginalHeader
      logo={uiConfig.images.header_logo}
      info={{
        name: uiConfig.listings.title,
      }}
      className="header"
      isMulti
    >
      {children}
    </OriginalHeader>
  );
};
